<template>
  <div class="wrapper sceneList template">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
    <el-dialog :title="$t('im.sceneList.addTitle')" :visible.sync="isCreateScenes">
      <div class="padding scrollY" :style="{'max-height':util.accSub((util.accDiv(height,1.3)),190)+'px'}">
        <el-form class="div_form"
                 label-width="80px"
                 ref="createScenesForm"
                 :rules="scenesRules"
                 :model="createScenesForm">
          <el-form-item :label="$t('im.sceneList.name')" prop="title" required>
            <el-input v-model="createScenesForm.title" :placeholder="$t('im.sceneList.namePlaceholder')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('im.sceneList.formBizCode')" prop="businessGroupCode" required>
            <el-select v-model="createScenesForm.businessGroupCode" :placeholder="$t('im.sceneList.formBizCode')">
              <el-option
                v-for="item in businessGroupData"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('im.common.locale')" prop="lang" required>
            <el-select v-model="createScenesForm.lang" :placeholder="$t('im.sceneList.localePlaceholder')">
              <el-option
                v-for="item in langList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('im.sceneList.welcomeMessage')">
            <quill ref="quill" :uploadUrl="createScenesForm.uploadUrl" :quillId="createScenesForm.quillId" :height="300"></quill>
          </el-form-item>
          <el-form-item :label="$t('im.sceneList.recommendKnowledge')">
            <el-button type="primary" size="small" @click="addKnowledge"><i class="el-icon-edit el-icon--left"></i>{{$t('im.sceneList.selectKnowledge')}}
            </el-button>
            <el-table border :data="createScenesForm.data" tooltip-effect="dark" style="width: 100%" class="sceneTable">
              <el-table-column :prop="item.id" :label="item.name" v-for="item in createScenesForm.dataNav"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column :label="$t('im.bt.operator')">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" @click="delKnowledge(scope.row,scope.$index)">
                    {{$t('im.bt.delete')}}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item :label="$t('im.sceneList.manualService')" style="margin-bottom: 0">
            <el-checkbox v-model="createScenesForm.artificial">{{$t('im.sceneList.directManualService')}}</el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('im.common.enable')">
            <el-radio v-model="createScenesForm.status" label="1">{{$t('im.common.enableYes')}}</el-radio>
            <el-radio v-model="createScenesForm.status" label="0">{{$t('im.common.enableNo')}}</el-radio>
          </el-form-item>
        </el-form>
      </div>
      <div class="flexCenter">
        <el-button type="primary" size="small" @click="saveScenes('createScenesForm')">{{$t('im.bt.save')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('im.sceneList.selectKnowledge')" :visible.sync="isCheckKnowledge" width="55%">
      <div class="padding scrollY" :style="{'max-height':util.accSub((util.accDiv(height,1.3)),190)+'px'}">
        <el-form :inline="true" class="div_form">
          <el-form-item :label="$t('im.sceneList.knowledgeTitle')">
            <el-input v-model="checkKnowledgeForm.title"
                      :placeholder="$t('im.sceneList.knowledgeTitlePlaceholder')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('im.sceneList.knowledgeType')">
            <el-select v-model="checkKnowledgeForm.type" :placeholder="$t('im.sceneList.knowledgeTypePlaceholder')">
              <el-option
                v-for="item in checkKnowledgeForm.typeData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('im.sceneList.formBizCode')">
            <el-select v-model="checkKnowledgeForm.businessGroupCode"
                       :placeholder="$t('im.sceneList.formBizCodePlaceholder')">
              <el-option
                v-for="item in businessGroupData"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('im.common.locale')">
            <el-select v-model="checkKnowledgeForm.lang" :placeholder="$t('im.sceneList.localePlaceholder')">
              <el-option
                v-for="item in langList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('im.sceneList.startDate')">
            <el-date-picker
              v-model="checkKnowledgeForm.startTime"
              type="datetime"
              :placeholder="$t('im.sceneList.startDatePlaceholder')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('im.sceneList.endDate')">
            <el-date-picker
              v-model="checkKnowledgeForm.endTime"
              type="datetime"
              :placeholder="$t('im.sceneList.endDatePlaceholder')">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="div_btn">
            <el-button type="primary" size="small" @click="searchKnowledgeList">{{$t('im.bt.search')}}</el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="multipleTable"
          border
          tooltip-effect="dark"
          style="width: 100%"
          :data="checkKnowledgeForm.data"
          @selection-change="selectKnowledge">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column :prop="item.id" :label="item.name" v-for="item in checkKnowledgeForm.dataNav"
                           :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <div class="block flexEnd" v-if="checkKnowledgeForm.totalNum>0">
          <el-pagination
            background
            @size-change="pageSizeChange"
            @current-change="currentChange"
            :current-page="checkKnowledgeForm.currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="checkKnowledgeForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="checkKnowledgeForm.totalNum">
          </el-pagination>
        </div>
      </div>
      <div class="flexCenter">
        <el-button type="primary" size="small" @click="saveSelectKnowledge">{{$t('im.bt.save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Util from '@/utils/IM/tradeDataUtil'
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import quill from '@/views/IM/model/quill.vue'
  //接口地址url的统一管理
  import apiChatSystem from '@/api/im/chatSystem'
  import URL from '@/api/im/url'
  import { localRead } from '@/utils/tools'
  import Qs from 'qs'

  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE,
      quill
    },
    data() {
      return {
        util: Util,
        height: '',
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),  //用户信息
        langList: JSON.parse(localRead('locale_IM')),  //语言列表
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,  //业务编码列表
        enableType: [
          { value: 0, title: window.$t('im.common.enableNo') },
          { value: 1, title: window.$t('im.common.enableYes') }
        ],
        yesOrNoType: [
          { value: 0, title: window.$t('im.common.no') },
          { value: 1, title: window.$t('im.common.yes') }
        ],
        bizCodeObj: {},
        localeObj: {},
        enableObj: {},
        yesOrNoObj: {},
        deleteIds: '',
        queryData: {},
        bizCodes: [],
        locales: [],
        /*新增或更新*/
        updateData: {},
        /*from查询表单*/
        formData: {
          hasLable: true,
          cols: []
        },
        /*table生成*/
        pageData: {
          isShow: false,
          queryUrl: URL.sceneKnowledge.sceneKnowledgeList, //请求路径和参数
          selection: false,
          sequence: false,
          method: 'post-json',
          cols: [
            { title: 'ID', field: 'id' },
            { title: window.$t('im.sceneList.name'), field: 'name' },
            {
              title: window.$t('im.sceneList.welcomeMessage'), field: 'welcomeMessage', render: (data) => {
                return data
              }
            },
            {
              title: window.$t('im.common.bizCode'), field: 'bizCode', render: (data) => {
                return this.brushBusinessGroup(data)
              }
            },
            {
              title: window.$t('im.common.locale'), field: 'locale', render: (data) => {
                return this.brushLocale(data)
              }
            },
            {
              title: window.$t('im.sceneList.directManual'), field: 'directManual', render: (data) => {
                return this.getDesc(this.yesOrNoType, data)
              }
            },
            {
              title: window.$t('im.common.enable'), field: 'enable', render: (data) => {
                return this.getDesc(this.enableType, data)
              }
            },
            { title: window.$t('im.common.createDate'), field: 'createDate' },
            { title: window.$t('im.common.updateDate'), field: 'updateDate' },
            {
              title: window.$t('im.bt.operator'), btnClick: [
                { name: window.$t('im.bt.update'), size: 'mini', click: 'update', type: 'primary' },
                { name: window.$t('im.bt.delete'), size: 'mini', click: 'delete', type: 'primary' }]
            }
          ]
        },
        isCreateScenes: false,
        createScenesForm: {
          id: '',
          title: '',
          businessGroupCode: '',
          lang: '',
          quillId: 'quillID',
          uploadUrl: process.env.VUE_APP_BASE_API + '/serviceBusiness/api/upload/uploadMulti',
          data: [],
          dataNav: [
            { name: window.$t('im.sceneList.knowledgeId'), id: 'id' },
            { name: window.$t('im.sceneList.knowledgeName'), id: 'name' }
          ],
          artificial: false,
          status: '1'
        },
        scenesRules: {
          title: [
            { required: true, message: window.$t('im.sceneList.formKnowledgeTitleValid'), trigger: 'blur' }
          ],
          businessGroupCode: [
            { required: true, message: window.$t('im.sceneList.formKnowledgeBizCodeValid'), trigger: 'change' }
          ],
          lang: [
            { required: true, message: window.$t('im.sceneList.formKnowledgeLocaleValid'), trigger: 'change' }
          ]
        },
        scenesType: 0,//0:保存，1：更新
        isCheckKnowledge: false,
        checkKnowledgeForm: {
          title: '',
          type: '',
          typeData: [],
          businessGroupCode: '',
          lang: '',
          startTime: '',
          endTime: '',
          data: [],
          dataNav: [
            { name: window.$t('im.sceneList.knowledgeId'), id: 'id' },
            { name: window.$t('im.sceneList.knowledgeName'), id: 'name' },
            { name: window.$t('im.sceneList.knowledgeType'), id: 'categoryIdName' },
            { name: window.$t('im.common.bizCode'), id: 'bizCodeName' },
            { name: window.$t('im.common.locale'), id: 'localeName' },
            { name: window.$t('im.common.createDate'), id: 'createDate' }
          ],
          currentPage: 1,  //当前页数
          pageSize: 10, //当前页条数数
          totalNum: 0,  //当前资源条数
          selectData: []//选中知识
        }
      }
    },
    created() {
      for (const i in this.businessGroupData) {
        let code = this.businessGroupData[i].code
        let name = this.businessGroupData[i].name
        this.bizCodeObj[code] = name
        this.bizCodes.push(code)
      }
      for (const i in this.langList) {
        let code = this.langList[i].id
        let name = this.langList[i].name
        this.localeObj[code] = name
        this.locales.push(code)
      }
      for (const i in this.enableType) {
        let code = this.enableType[i].value
        let name = this.enableType[i].title
        this.enableObj[code] = name
      }
      for (const i in this.yesOrNoType) {
        let code = this.yesOrNoType[i].value
        let name = this.yesOrNoType[i].title
        this.yesOrNoObj[code] = name
      }
      this.updateData = {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          { title: window.$t('im.sceneList.name'), field: 'name', required: true },
          { title: window.$t('im.sceneList.welcomeMessage'), field: 'welcomeMessage', textType: 'textarea' },
          {
            title: window.$t('im.common.bizCode'),
            field: 'bizCode',
            type: 2,
            required: true,
            optionList: this.bizCodeObj
          },
          {
            title: window.$t('im.common.locale'),
            field: 'locale',
            type: 2,
            required: true,
            optionList: this.localeObj
          },
          {
            title: window.$t('im.sceneList.directManual'),
            field: 'directManual',
            type: 2,
            required: true,
            optionList: this.yesOrNoObj,
            isNumber: true,
            data: 0
          },
          {
            title: window.$t('im.common.enable'),
            field: 'enable',
            type: 2,
            required: true,
            optionList: this.enableObj,
            isNumber: true,
            data: 1
          }
        ]
      },
        this.formData.cols = [
          {
            title: window.$t('im.common.companyId'),
            field: 'companyId',
            hidden: 'true',
            data: this.userInfo.companyId
          },
          { title: window.$t('im.sceneList.name'), field: 'name' },
          { title: window.$t('im.common.bizCode'), field: 'bizCode', type: 2, optionList: this.bizCodeObj },
          { title: window.$t('im.common.locale'), field: 'locale', type: 2, optionList: this.localeObj },
          {
            title: window.$t('im.sceneList.createDateRange'),
            field: 'createDateRange',
            type: 6,
            isArray: true,
            format: 'yyyy-MM-dd HH:mm:ss',
            startEndParam: ['queryStartTime', 'queryEndTime']
          },
          { click: window.$t('im.bt.search') },
          { click: window.$t('im.bt.reset') },
          { click: window.$t('im.bt.add') }
        ]
    },
    methods: {
      docHeight() {
        this.height = window.innerHeight || document.documentElement.clientHeight
      },
      /*表格按钮点击事件*/
      bthClick(clickName, row) {
        if (clickName == 'update') {
          this.isCreateScenes = true
          this.scenesType = 1
          this.createScenesForm.id = row.id
          this.createScenesForm.title = row.name
          this.createScenesForm.businessGroupCode = row.bizCode
          this.createScenesForm.lang = row.locale
          this.createScenesForm.artificial = row.directManual == 1 ? true : false
          this.$nextTick(() => {
            this.$refs.quill.init(row.welcomeMessage)
          })
          this.createScenesForm.status = row.enable.toString()
          this.initKnowledge(row.knowledge)
        } else if (clickName == 'delete') {
          this.dataDelete(URL.sceneKnowledge.sceneKnowledgeDelete, { id: row.id }, res => {
            if (res.code == 0) {
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        } else if (clickName == 'enableOrNot') {
          row['enable'] = row['enable'] == 0 ? 1 : 0
          this.dataChanage(URL.sceneKnowledge.sceneKnowledgeUpdate, row, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close()
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data) {
        if ('查询' == clickName || window.$t('im.bt.search') == clickName) {
          data['bizCodes'] = this.bizCodes
          data['locales'] = this.locales
          this.queryData = data
          this.$refs.childTable.defaultGetData(data)
        } else if ('新增' == clickName || window.$t('im.bt.add') == clickName) {
          this.isCreateScenes = true
          this.scenesType = 0
          if (this.$refs.createScenesForm) {
            this.$refs.createScenesForm.resetFields()
          }
          this.createScenesForm.title = ''
          this.createScenesForm.businessGroupCode = ''
          this.createScenesForm.lang = ''
          this.$nextTick(() => {
            this.$refs.quill.init('')
          })
          this.createScenesForm.data = []
          this.createScenesForm.artificial = false
          this.createScenesForm.status = '1'
        } else if ('重置' == clickName || window.$t('im.bt.reset') == clickName) {
          this.formData.cols = [
            {
              title: window.$t('im.common.companyId'),
              field: 'companyId',
              hidden: 'true',
              data: this.userInfo.companyId
            },
            { title: window.$t('im.sceneList.name'), field: 'name' },
            { title: window.$t('im.common.bizCode'), field: 'bizCode', type: 2, optionList: this.bizCodeObj },
            { title: window.$t('im.common.locale'), field: 'locale', type: 2, optionList: this.localeObj },
            {
              title: window.$t('im.common.createDate'),
              field: 'createDateRange',
              type: 6,
              isArray: true,
              format: 'yyyy-MM-dd HH:mm:ss',
              startEndParam: ['queryStartTime', 'queryEndTime']
            },
            { click: window.$t('im.bt.search') },
            { click: window.$t('im.bt.reset') },
            { click: window.$t('im.bt.add') }
          ]
          this.$refs.childForm.queryListData()
        } else if ('列表显示隐藏' == clickName || window.$t('im.bt.hideOrNo') == clickName) {
          this.pageData.isShow = !this.pageData.isShow
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model) {
        //根据是否包含id更新还是添加
        if (!!model.id) {
          this.dataChanage(URL.sceneKnowledge.sceneKnowledgeUpdate, model, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close()
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.dataChanage(URL.sceneKnowledge.sceneKnowledgeAdd, model, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close()
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
      dataChanage(url, option, suc, fail) {
        option['operatorName'] = this.userInfo.displayName
        option['operator'] = this.userInfo.id
        option['companyId'] = this.userInfo.companyId
        this.$axios.post(url, option, {
          headers: {
            'isAjax': 'true',
            'Content-Type': 'application/json'
          }
        }).then(res => {
          this.$refs.childTable.defaultGetData(this.queryData)
          if (suc && (typeof suc == 'function')) suc(res)
        }).catch(res => {
          if (fail && (typeof fail == 'function')) fail(res)
        })
      },
      dataDelete(url, option, suc, fail) {
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
          this.$refs.childTable.defaultGetData(this.queryData)
          if (suc && (typeof suc == 'function')) suc(res)
        }).catch(res => {
          if (fail && (typeof fail == 'function')) fail(res)
        })
      },
      getDesc(array, value) {
        let res = ''
        array.forEach(item => {
          if (item.value === value) {
            res = item.title
            return res
          }
        })
        return res
      },
      brushBusinessGroup(data) {
        for (const i in this.businessGroupData) {
          if (this.businessGroupData[i].code == data) {
            return this.businessGroupData[i].name
          }
        }
        return ''
      },
      brushLocale(data) {
        for (const i in this.langList) {
          if (this.langList[i].id == data) {
            return this.langList[i].name
          }
        }
        return ''
      },
      brushKnowledgeType(data) {
        for (const i in this.checkKnowledgeForm.typeData) {
          if (this.checkKnowledgeForm.typeData[i].id == data) {
            return this.checkKnowledgeForm.typeData[i].name
          }
        }
        return ''
      },
      /*新增知识*/
      addKnowledge() {
        this.isCheckKnowledge = true
        this.checkKnowledgeForm.title = ''
        this.checkKnowledgeForm.type = ''
        this.checkKnowledgeForm.businessGroupCode = ''
        this.checkKnowledgeForm.lang = ''
        this.checkKnowledgeForm.startTime = ''
        this.checkKnowledgeForm.endTime = ''
        this.initKnowledgeCategory()
      },
      /*删除知识*/
      delKnowledge(obj, index) {
        this.createScenesForm.data.splice(index, 1)
      },
      /*初始化知识分类列表*/
      initKnowledgeCategory() {
        let data = { companyId: this.userInfo.companyId }
        apiChatSystem.queryConKnowledgeCategoryList(data).then(res => {
          if (res.code == 0) {
            if (res.result && res.result.length > 0) {
              this.checkKnowledgeForm.typeData = res.result
              this.initKnowledgeList()
            }
          }
        })
      },
      getKnowledgeList(data) {
        apiChatSystem.queryConKnowledgeListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result.list && res.result.list.length > 0) {
              let oldData = JSON.parse(JSON.stringify(res.result.list))
              for (const i in oldData) {
                oldData[i].bizCodeName = this.brushBusinessGroup(oldData[i].bizCode)
                oldData[i].localeName = this.brushLocale(oldData[i].locale)
                oldData[i].categoryIdName = this.brushKnowledgeType(oldData[i].categoryId)
              }
              this.checkKnowledgeForm.data = oldData
              this.$nextTick(() => {
                if (this.createScenesForm.data.length > 0) {
                  this.createScenesForm.data.forEach(obj => {
                    this.$refs.multipleTable.toggleRowSelection(this.checkKnowledgeForm.data.find(item => {
                      return obj.id == item.id
                    }), true)
                  })
                }
              })
            } else {
              this.checkKnowledgeForm.data = []
            }
            this.checkKnowledgeForm.totalNum = res.result.total
          }
        })
      },
      /*初始化知识列表*/
      initKnowledgeList() {
        let data = {
          companyId: this.userInfo.companyId,
          pageNum: 1,
          pageSize: this.checkKnowledgeForm.pageSize,
          bizCodes: this.bizCodes,
          locales: this.locales
        }
        this.getKnowledgeList(data)
      },
      /*查询不同条件知识列表*/
      searchKnowledgeList() {
        let data = {
          companyId: this.userInfo.companyId,
          bizCodes: this.bizCodes,
          locales: this.locales,
          pageNum: 1,
          pageSize: this.checkKnowledgeForm.pageSize,
          bizCode: this.checkKnowledgeForm.businessGroupCode,
          locale: this.checkKnowledgeForm.lang,
          title: this.checkKnowledgeForm.title,
          categoryId: this.checkKnowledgeForm.type,
          queryStartTime: this.checkKnowledgeForm.startTime,
          queryEndTime: this.checkKnowledgeForm.endTime
        }
        this.getKnowledgeList(data)
      },
      /*选择知识列表显示条数*/
      pageSizeChange(val) {
        this.checkKnowledgeForm.pageSize = val
        let data = {
          companyId: this.userInfo.companyId,
          bizCodes: this.bizCodes,
          locales: this.locales,
          pageNum: this.checkKnowledgeForm.currentPage,
          pageSize: val,
          bizCode: this.checkKnowledgeForm.businessGroupCode,
          locale: this.checkKnowledgeForm.lang,
          title: this.checkKnowledgeForm.title,
          categoryId: this.checkKnowledgeForm.type,
          queryStartTime: this.checkKnowledgeForm.startTime,
          queryEndTime: this.checkKnowledgeForm.endTime
        }
        this.getKnowledgeList(data)
      },
      /*切换知识列表页数*/
      currentChange(val) {
        this.checkKnowledgeForm.currentPage = val
        let data = {
          companyId: this.userInfo.companyId,
          bizCodes: this.bizCodes,
          locales: this.locales,
          pageNum: val,
          pageSize: this.checkKnowledgeForm.pageSize,
          bizCode: this.checkKnowledgeForm.businessGroupCode,
          locale: this.checkKnowledgeForm.lang,
          title: this.checkKnowledgeForm.title,
          categoryId: this.checkKnowledgeForm.type,
          queryStartTime: this.checkKnowledgeForm.startTime,
          queryEndTime: this.checkKnowledgeForm.endTime
        }
        this.getKnowledgeList(data)

      },
      /*选中知识*/
      selectKnowledge(val) {
        this.checkKnowledgeForm.selectData = val
      },
      /*初始化推荐知识*/
      initKnowledge(ids) {
        let data = {
          ids: ids
        }
        apiChatSystem.querySceneConKnowledge(data).then(res => {
          if (res.code == 0) {
            if (res.result && res.result.length > 0) {
              this.createScenesForm.data = res.result
            } else {
              this.createScenesForm.data = []
            }
          }
        })
      },
      /*保存选中知识*/
      saveSelectKnowledge() {
        this.isCheckKnowledge = false
        this.createScenesForm.data = this.checkKnowledgeForm.selectData
      },
      /*新增场景*/
      addScenes(data) {
        apiChatSystem.addConSceneKnowledge(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.isCreateScenes = false
            this.$refs.childForm.queryListData()
          }
        })
      },
      /*更新场景*/
      updateScenes(data) {
        apiChatSystem.updateConSceneKnowledge(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.isCreateScenes = false
            this.$refs.childForm.queryListData()
          }
        })
      },
      /*保存场景*/
      saveScenes(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let ids = []
            for (const i in this.createScenesForm.data) {
              ids.push(this.createScenesForm.data[i].id)
            }
            let data = {
              companyId: this.userInfo.companyId,
              operatorName: this.userInfo.displayName,
              operator: this.userInfo.id,
              name: this.createScenesForm.title,
              bizCode: this.createScenesForm.businessGroupCode,
              locale: this.createScenesForm.lang,
              welcomeMessage: this.$refs.quill.getHtml(),
              knowledge: ids.join(','),
              directManual: this.createScenesForm.artificial ? 1 : 0,
              enable: Number(this.createScenesForm.status)
            }
            let arr = { id: this.createScenesForm.id }
            if (this.scenesType == 0) {
              this.addScenes(data)
            } else if (this.scenesType == 1) {
              let obj = { ...data, ...arr }
              this.updateScenes(obj)
            }
          } else {
            return false
          }
        })
      }
    },
    mounted() {
      this.docHeight()
    }
  }
</script>
<style>
  .sceneList .div_form .el-select {
    width: 100%
  }

  .sceneList .sceneTable.el-table {
    margin-top: 10px
  }

  .sceneList .sceneTable.el-table td, .sceneList .sceneTable.el-table th {
    padding: 5px 0;
  }
</style>
